/* eslint-disable */
import ptBr from '../../../public/locales/pt/pt-br.json'
import { useTranslation } from 'react-i18next'

function getObjectKeys<T extends Record<string, any>>(
  obj: T,
  acc: string
): { [K in keyof T]: T[K] extends string ? string : ReturnType<typeof getObjectKeys> } {
  const objValue: any = {};

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value !== 'string') {
      objValue[key] = getObjectKeys(value, acc === '' ? `${key}` : `${acc}.${key}`);
    } else {
      objValue[key] = `${acc}.${key}`;
    }
  }

  return objValue;
}

const useTranslator = () => {
  const { t } = useTranslation()
  const k = getObjectKeys(ptBr, '') as typeof ptBr

  const translate = (text: string) => {
    return t(text)
  }

  const translaStrippedKey = (key: string, obj?:any) => {
    const strippedKey = key.startsWith('translation.') ? key.replace('translation.', '') : key;
    return t(strippedKey, obj);
  };

  return {
    translate,
    t: translaStrippedKey,
    k,
  }
}

export default useTranslator
